import { type StartProductionInput, startProductionInputSchema } from '@repo/api-contracts';
import { useId, useState } from 'react';
import { formStyles, Input, Label, OrderActionDialog } from '@/shared/ui';

interface OrderProductionDialogProps {
  readonly orderId: string;
  readonly expectedShipDate: string | null;
  readonly today: string;
  readonly onSubmit: (input: StartProductionInput) => Promise<unknown>;
  readonly onReload: () => void;
  readonly onClose: () => void;
  readonly pending?: boolean;
}

/** 제작 착수 — 출고 예정일(기본값: 기존 예정일 또는 한국 오늘, 오늘 이상)을 정한다. 착수 뒤에는 고객이 취소 요청을 할 수 없다. */
export function OrderProductionDialog({
  orderId,
  expectedShipDate,
  today,
  onSubmit,
  onReload,
  onClose,
  pending,
}: OrderProductionDialogProps) {
  const id = useId();
  const [date, setDate] = useState(expectedShipDate ?? today);
  return (
    <OrderActionDialog
      title="제작 착수"
      submitLabel="제작 착수"
      onReload={onReload}
      onClose={onClose}
      pending={pending}
      validate={() =>
        !startProductionInputSchema.safeParse({ orderId, expectedShipDate: date }).success ||
        date < today
          ? '출고 예정일은 오늘 이상이어야 합니다.'
          : null
      }
      onSubmit={async () => {
        await onSubmit({ orderId, expectedShipDate: date });
      }}
    >
      <p className={formStyles.notice}>제작 착수 뒤에는 고객이 취소 요청을 할 수 없습니다.</p>
      <div className={formStyles.field}>
        <Label htmlFor={`${id}-date`}>출고 예정일</Label>
        <Input
          id={`${id}-date`}
          type="date"
          min={today}
          value={date}
          onChange={(event) => setDate(event.target.value)}
        />
      </div>
    </OrderActionDialog>
  );
}
